export default __webpack_public_path__ + "static/media/georgie-cobbs-yfgptSTq2SQ-unsplash-removebg (1) 1.f6d70d85.png";